import {Component, OnInit} from '@angular/core';
import {AbstractDisplayComponent} from '../abstract-display.component';
import {CacheJsService, ConfiguratorI18nCacheService} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-operator-display',
    templateUrl: './operator-display.component.html',
    styleUrls: ['./operator-display.component.scss'],
    standalone: false
})
export class OperatorDisplayComponent extends AbstractDisplayComponent implements OnInit {


    constructor(
        private readonly cacheJsService: CacheJsService,
        private readonly configuratorI18nCacheService: ConfiguratorI18nCacheService) {
        super();
    }

    ngOnInit() {
        this.display = this.value;
        this.displayHover = '...';
    }

    getTooltip() {
        const group = 'AIRLINE';
        if (this.cacheJsService.existGroupKey(group, this.value)) {
            this.displayHover = this.cacheJsService.getValueByGroupKey(group, this.value).value;
        } else {
            this.configuratorI18nCacheService.getByKeyUsingGET(group, false, this.value).subscribe(res => {
                this.cacheJsService.addGroupKeyValue(group, this.value, res);
                this.displayHover = res.value;
            });
        }
    }

}
